import config from '../../config'
import { HTTP } from  '../../http'

export default {
    getAll: (keywords, eventId) => {
        let s = eventId == null || eventId == '' ? '' : `&eventId=${eventId}`;
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.salesUsersUri.concat(`?keywords=${keywords}${s}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}